<template>
  <BaseDialog
    :is-open="isOpen"
    :title="$t('survey.finish.confirmation')"
    type="basic"
    :description="$t('survey.finish.description')"
    @close="emits('close')"
  >
    <template #dismiss
      ><BaseTextButton color="text" size="M" @click="emits('close')">{{
        $t('common.cancel')
      }}</BaseTextButton>
    </template>
    <template #confirm
      ><BaseTextButton color="filled" size="M" @click="emits('fnishSurvey')">{{
        $t('survey.finish.action')
      }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script lang="ts" setup>
  import BaseTextButton from '../../../core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '../../../core/components/base/dialog/BaseDialog.vue'
  interface Props {
    isOpen: boolean
  }

  defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'fnishSurvey'): void
  }>()
</script>
